import React from "react";
import "./styles.scss";
import { FormField } from "../../components";
import { translate } from "../../translations/localization";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { Base64 } from "js-base64";
import Lottie from "lottie-react";
import contactEmailAnimation from "../../assets/icons/contact-email.json";

const videos = ["https://hydropro.s3.eu-central-1.amazonaws.com/hydropro-website/Hydropro+BG+corporate+video.mp4", "https://hydropro.s3.eu-central-1.amazonaws.com/hydropro-website/Hydropro+BG+%D0%9A%D0%BE%D1%80%D0%BF%D0%BE%D1%80%D0%B0%D1%82%D0%B8%D0%B2%D0%BD%D0%BE+%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE_+Hydropro+BG+corporate+video.mp4"];

const DEFAULT_PHONE_COUNTRY_CODE = "+359";
const PHONE_VALIDATION_REGEX = /^\+\d{1,4}\d{6,14}$/;

export default function AboutUs() {
  const videoRef = useRef(null);
  const mobileVideoRef = useRef([]);
  const sliderRef = useRef();

  const [currentVideo, setCurrentVideo] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [velocity, setVelocity] = useState(0);

  const [formData, setFormData] = useState({ name: "", phone: "", phonePrefix: DEFAULT_PHONE_COUNTRY_CODE, email: "", message: "" });
  const [formErrors, setFormErrors] = useState({ name: "", phone: "", email: "", message: "" });
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const buildFullPhone = (prefix, local) => {
    const cleanPrefix = (prefix || "").replace(/[^\d+]/g, "");
    const cleanLocal = (local || "").replace(/\D/g, "");
    return cleanPrefix + cleanLocal;
  };

  const validateAll = (data) => ({
    name: !data.name.trim() ? translate("inquiryErrorRequired") : !/^[\p{L}\s\-']+$/u.test(data.name) ? translate("inquiryErrorLettersOnly") : "",
    email: !data.email.trim() ? translate("inquiryErrorRequired") : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email) ? translate("inquiryErrorInvalidEmail") : "",
    phone: !data.phone.trim() ? translate("inquiryErrorRequired") : !PHONE_VALIDATION_REGEX.test(buildFullPhone(data.phonePrefix, data.phone)) ? translate("inquiryErrorInvalidPhone") : "",
    message: !data.message.trim() ? translate("inquiryErrorRequired") : "",
  });

  const isFormValid = formData.name.trim() !== "" && formData.phone.trim() !== "" && formData.email.trim() !== "" && formData.message.trim() !== "";

  const handleFormChange = (field) => (e) => {
    const value = e.target.value;
    if (field === "name" && value !== "" && !/^[\p{L}\s\-']*$/u.test(value)) return;
    if (field === "phone" && value !== "" && !/^[\d\s\-()]*$/.test(value)) return;
    if (field === "phonePrefix") {
      const cleaned = value.startsWith("+") ? "+" + value.slice(1).replace(/\D/g, "") : "+" + value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, phonePrefix: cleaned.slice(0, 5) }));
      return;
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (isSubmitting) return;
    const errors = validateAll(formData);
    setFormErrors(errors);
    if (Object.values(errors).every((e) => e === "")) {
      const { name, email, message } = formData;
      const phone = buildFullPhone(formData.phonePrefix, formData.phone);
      const today = new Date().toLocaleDateString("bg-BG");

      setIsSubmitting(true);
      window.fetch("https://mailer.fidweb.net/mail/send/hydropro", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + Base64.encode("hydropro:P0div3h!!!ot!!T4z!!K4rantinaBEEEEE"),
        },
        body: JSON.stringify({
          from: email,
          to: "export@hydropro.bg, Lazarov@fidweb.net",
          subject: "HydroPro - Контакти",
          body: `Изпратено от: ${name}\nEmail: ${email}\nТелефон за връзка: ${phone}\nСъобщение: ${message}`,
          notifyBody: `
            <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
            <html xmlns="http://www.w3.org/1999/xhtml">
            <head>
              <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <title>HydroPro</title>
              <style type="text/css">
                * { font-family: Georgia, Times, Times New Roman, serif; }
                body { width: 100% !important; margin: 0; padding: 0; background-color: #ffffff; font-size: 16px; }
              </style>
            </head>
            <body>
              <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#ffffff">
                <tr>
                  <td align="center">
                    <table cellpadding="0" cellspacing="0" border="0" width="600">
                      <tr>
                        <td>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td style="text-align:right;font-size:12px;color:#201E18;">дата ${today}г.</td>
                            </tr>
                          </table>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr><td align="center"><img src="https://hydropro.bg/email/hydropro-header.jpg" alt="HydroPro" border="0" width="600" /></td></tr>
                          </table>
                          <h1 style="text-align:center;font-size:34px;color:#201E18;font-weight:normal;font-family:Georgia,Times,Times New Roman,serif;">Свързахте се с HydroPro</h1>
                          <p style="font-size:18px;line-height:24px;color:#201E18;">Вие изпратихте запитване към HydroPro:</p>
                          <p style="font-size:18px;line-height:24px;color:#201E18;">
                            Изпратено от: ${name}<br/>
                            Мейл: ${email}<br/>
                            Телефон за връзка: ${phone}<br/>
                            Съобщение: ${message}
                          </p>
                          <p style="font-size:18px;line-height:24px;color:#201E18;">Съвсем скоро ще отговорим на вашето запитване!<br/>- HydroPro</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            </html>
          `,
          notifySubject: "HydroPro - Получено запитване",
        }),
      })
        .then(() => setIsSuccess(true))
        .catch(() => alert(translate("inquiryErrorGeneral")))
        .finally(() => setIsSubmitting(false));
    }
  };

  let lastX = 0;
  let lastTime = 0;

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoEnded = () => setIsPlaying(false);

  const handleVideoChange = (index) => {
    if (index === currentVideo) return;
    setCurrentVideo(index);
    setIsPlaying(false);
    videoRef.current.pause();
    videoRef.current.src = videos[index]; // Update source directly
    videoRef.current.load(); // Force video reload
  };


  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    slider.addEventListener("scroll", handleScroll);
    return () => slider.removeEventListener("scroll", handleScroll);
  }, []);

  // Touch start event
  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX);
    setScrollLeft(sliderRef.current.scrollLeft);
    lastX = e.touches[0].pageX;
    lastTime = Date.now();
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX;
    const delta = x - startX;
    sliderRef.current.scrollLeft = scrollLeft - delta;

    const timeNow = Date.now();
    const deltaTime = timeNow - lastTime;
    setVelocity((x - lastX) / deltaTime);
    lastX = x;
    lastTime = timeNow;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    let momentum = velocity * 100;

    const momentumScroll = () => {
      if (Math.abs(momentum) < 1) return;
      sliderRef.current.scrollLeft += momentum;
      momentum *= 0.9;
      requestAnimationFrame(momentumScroll);
    };

    momentumScroll();
  };

  const handleScroll = () => {
    if (!sliderRef.current) return;

    const scrollX = sliderRef.current.scrollLeft;
    const videoWidth = sliderRef.current.clientWidth;
    const newIndex = Math.round(scrollX / videoWidth);

    mobileVideoRef.current.map((el) => el.pause());
    setCurrentVideo(newIndex);
  };

  const handleDotClick = (index) => {
    if (!sliderRef.current) return;
    const videoWidth = sliderRef.current.clientWidth;
    sliderRef.current.scrollTo({
      left: videoWidth * index,
      behavior: "smooth",
    });
    mobileVideoRef.current.forEach((video) => video?.pause());
    if (mobileVideoRef.current[index]) mobileVideoRef.current[index].currentTime = 0;
    setCurrentVideo(index);
    setIsPlaying(false);
  };

  return (
    <div className="about-us">
      <div className="container">
        <div className="contact-section-wrapper">
          <div className="about-us-info-wrapper">
            <h1>{translate("headerAboutUs")}</h1>
            {window.innerWidth < 900 ? (
              <>
                <div className="video-slider" ref={sliderRef} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
                  {videos?.map((video, index) => (
                    <div key={index} className="video-slide">
                      <video
                        ref={(el) => (mobileVideoRef.current[index] = el)} // Assign unique ref
                        className="video-element"
                        preload="metadata"
                        playsInline
                        controls
                        poster={index === 0 ? "/imgs/thumbnail1.png" : "/imgs/thumbnail2.png"}
                        onPlay={() => handlePlay(index)}
                        onEnded={() => handleVideoEnded(index)}
                      >
                        <source src={video} type="video/mp4" />
                      </video>
                    </div>
                  ))}
                </div>
                <div className="pagination">
                  {videos.map((_, index) => (
                    <div key={index} className={`dot ${currentVideo === index ? "active" : ""}`} onClick={() => handleDotClick(index)}></div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div id="video-container" className="video-outer-container">
                  <video ref={videoRef} className="video-container" preload="metadata" playsInline poster={currentVideo === 0 ? "/imgs/thumbnail1.png" : "/imgs/thumbnail2.png"} controls={isPlaying} onPlay={() => setIsPlaying(true)} onEnded={handleVideoEnded}>
                    <source src={videos[currentVideo]} type="video/mp4" />
                  </video>
                  {!isPlaying && (
                    <div className="play-button-icon" onClick={handlePlay}>
                      <div className="play-triangle"></div>
                    </div>
                  )}
                </div>
                <div className="pagination">
                  {videos.map((_, index) => (
                    <div key={index} className={`dot ${currentVideo === index ? "active" : ""}`} onClick={() => handleVideoChange(index)}></div>
                  ))}
                </div>
              </>
            )}

            <p>{translate("hydroproAboutUsInfo")}</p>
          </div>

          <div className="contacts-info-wrapper">
            <h1>{translate("contacts")}</h1>

            <div className="row">
              <img src={require("../../assets/icons/phone-blue.svg")} className="icon" alt="icon phone" />
              <p>+359 893 644 135</p>
            </div>
            <div className="row">
              <img src={require("../../assets/icons/mail-blue.svg")} className="icon" alt="icon mail" />
              <p>office@hydropro.bg</p>
            </div>
            <div className="row">
              <img src={require("../../assets/icons/location.svg")} className="icon" alt="icon location" />
              <p>{translate("contactsAddress")}</p>
            </div>

            <div className="row-wrapper">
              <div className="row" style={{ marginLeft: "2px" }}>
                <img src={require("../../assets/icons/LinkedIn-icon.svg")} className="icon" alt="icon linkedIn" />
                <p style={{ paddingTop: "5px" }} onClick={() => window.open("https://www.linkedin.com/company/hydroprobg/")}>
                  HydroproBG
                </p>
              </div>
              <div className="row">
                <img src={require("../../assets/icons/facebook.svg")} className="icon" alt="icon facebook" />
                <p onClick={() => window.open("https://www.facebook.com/profile.php?id=100076252747868")}>Hydropro BG</p>
              </div>
            </div>
          </div>
        </div>
        <div className="news-section-wrapper">
          {isSuccess ? (
            <>
              <h1 className="inquiry-title inquiry-title--hidden-desktop">{translate("inquiryFormTitle")}</h1>
              <div className="inquiry-success">
                <Lottie animationData={contactEmailAnimation} loop={false} className="inquiry-success-icon" />
                <h2 className="inquiry-success-title">{translate("inquirySuccessTitle")}</h2>
                <p className="inquiry-success-text">{translate("inquirySuccessText")}</p>
              </div>
            </>
          ) : (
            <>
              <h1 className="inquiry-title">{translate("inquiryFormTitle")}</h1>
              <div className="inquiry-form">
                <FormField label={translate("inquiryFieldName")} placeholder={translate("inquiryFieldNamePlaceholder")} value={formData.name} onChange={handleFormChange("name")} error={formErrors.name} />
              </div>
              <div className="inquiry-form inquiry-form--row">
                <FormField label={translate("inquiryFieldPhone")} placeholder={translate("inquiryFieldPhonePlaceholder")} type="tel" inputMode="tel" prefix={formData.phonePrefix} onPrefixChange={handleFormChange("phonePrefix")} value={formData.phone} onChange={handleFormChange("phone")} error={formErrors.phone} />
                <FormField label={translate("inquiryFieldEmail")} placeholder={translate("inquiryFieldEmailPlaceholder")} type="email" inputMode="email" value={formData.email} onChange={handleFormChange("email")} error={formErrors.email} />
              </div>
              <div className="inquiry-form inquiry-form--message">
                <FormField label={translate("inquiryFieldMessage")} placeholder={translate("inquiryFieldMessagePlaceholder")} inputClassName="inquiry-input--message" value={formData.message} onChange={handleFormChange("message")} error={formErrors.message} multiline />
              </div>
              
              <button className={`inquiry-submit${isFormValid ? " inquiry-submit--active" : ""}${isSubmitting ? " inquiry-submit--loading" : ""}`} onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? translate("inquirySubmitLoading") : translate("inquirySubmitButton")}</button>
            </>
          )}
        </div>
        {window.innerWidth < 900 && (
          <div style={{ height: "5vh", width: "20px", flex: "3", order: "3" }}>
            <p style={{ marginTop: "1px" }}></p>
          </div>
        )}
      </div>
    </div>
  );
}
